import { GrupoProdutoModel } from './../../model/produto/grupo-produto.model';
import { ResponsePageable } from './../../model/cliente/pageable/responsePageable.model';
import { Observable } from 'rxjs/Observable';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from './../../../environments/environment.prod';
import { Injectable } from '@angular/core';

@Injectable()
export class GrupoProdutoService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient) { }

  getPageGrupoProduto(page, size): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + `/view/listar-grupo-produto?page=${page}&size=${size}`, this.httpOptions);
  }

  getGrupoProduto(): Observable<ResponsePageable>{
    return this.httpClient.get<ResponsePageable>(this.apiURL + '/view/listar-grupo-produto', this.httpOptions);
  }

  postGrupoProduto(grupoProduto: GrupoProdutoModel): Observable<GrupoProdutoModel>{
    return this.httpClient.post<GrupoProdutoModel>(this.apiURL + '/new/adicionar-grupo-produto', grupoProduto, this.httpOptions);
  }

  putGrupoProduto(grupoProduto: GrupoProdutoModel): Observable<GrupoProdutoModel>{
    return this.httpClient.put<GrupoProdutoModel>(this.apiURL + '/edit/editar-grupo-produto', grupoProduto, this.httpOptions);
  }

  deleteGrupoProduto(id: any){
    const headers = new HttpHeaders()
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.get(this.apiURL + '/delete/apagar-grupo-produto/' + id, { responseType: 'text', headers });
  }

  getGrupoProdutoUnico(id: any): Observable<GrupoProdutoModel> {
    return this.httpClient.get<GrupoProdutoModel>(this.apiURL + '/view/listar-grupo-produto/' + id, this.httpOptions);
  }

}



// WEBPACK FOOTER //
// /app/src/app/service/produto/grupo-produto.service.ts